module.exports = __webpack_public_path__ + "static/media/down-purple.20543bac.svg";